import GeneralFeeSettings from "@/models/Products/ProductFees/GeneralFeeSettings";

export default class UpdateGeneralFeeSettingsRequest extends GeneralFeeSettings {
    updatedAt: Date;

    public constructor(settings: GeneralFeeSettings, updatedAt: Date) {
        super();
        this.updatedAt = updatedAt;
        if (settings) {
            this.overridable = settings.overridable;
            this.arbitraryFeesEnabled = settings.arbitraryFeesEnabled;
        }
    }
}